import React, { useCallback, useState } from 'react';
import Slider from 'react-slick';
import cn from 'classnames';

import APP_GOOGLE_LOGO from 'assets/images/slider/app-google-logos.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import CONF from 'config/conf.singleton';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import { trackEvent } from 'tracking/actions';

import CN from './SlickSlider.module.scss';

const LINK_TIPPING = 'https://www.getslick.com/tipping';
const LINK_REF = 'https://www.getslick.com/referral';
const MARKETING_SITE_TAS = `${CONF.marketingSite}/terms-and-conditions`;
const USE_SLIDE = false; // temporary flag to hide tipping slide until we have the final assets and copy

const SlickSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const { t } = useTranslation();

  const handleAfterChange = useCallback((index) => {
    setActiveSlide(index);
  }, []);

  const customPaging = useCallback(
    (index) => (
      <span
        className={cn({
          [CN.dot]: true,
          [CN.active]: index === activeSlide,
        })}
        onClick={() => handleAfterChange(index)}
      />
    ),
    [activeSlide, handleAfterChange],
  );

  return (
    <Slider
      dots
      dotsClass={CN.slickDots}
      customPaging={customPaging}
      arrows={false}
      infinite
      fade
      speed={1000}
      autoplay
      autoplaySpeed={4000}
      slidesToShow={1}
      slidesToScroll={1}
      afterChange={handleAfterChange}
      className={cn({
        [CN.component]: true,
      })}
    >
      {/* SLIDE new app 1*/}
      <div data-bem="SlickSlider__app" className={cn(CN.slideImage, CN.imageApp)}>
        <div className={CN.container}>
          <div className={CN.description}>
            <h2 className={CN.title}>{t('composite.slickSlider.slide1.title')}</h2>
            <h3 className={CN.secondTitle}>
              {t('composite.slickSlider.slide1.description.part1')}
              <br />
              {t('composite.slickSlider.slide1.description.part2')}
            </h3>
            <img src={APP_GOOGLE_LOGO} alt={t('composite.slickSlider.slide1.logoAlt')} className={CN.logo} />
          </div>
        </div>
      </div>
      {/* SLIDE referral 2*/}
      <div data-bem="SlickSlider__reff" className={cn(CN.slideImage, CN.imageReff)}>
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <span className={CN.emoji}>{S.womanRaisingHand}</span>
              <span className={CN.text}>{t('composite.slickSlider.slide2.title')}</span>
            </div>
            <h2 className={CN.title}>
              {t('composite.slickSlider.slide2.description.part1')}
              {S.space}
              <span className={CN.textWave}>{t('composite.slickSlider.slide2.description.part2')}</span>
            </h2>
            <div className={CN.linkContainer}>
              <ExternalLink variant="tertiaryLight" link={LINK_REF} onClick={() => trackEvent('login_vouchers')}>
                <span className={CN.link}>{t('composite.slickSlider.slide2.referFriendButton')}</span>
              </ExternalLink>
              <a href={MARKETING_SITE_TAS} className={CN.tAndC}>
                <span>{t('composite.slickSlider.slide2.termsAndConditions')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* SLIDE email 3*/}
      <div data-bem="SlickSlider__email" className={cn([CN.slideImage], [CN.imageEmail])}>
        <div className={CN.container}>
          <div className={CN.description}>
            <h3 className={CN.subTitle}>
              <span className={CN.text}>
                {S.email} {t('composite.slickSlider.slide3.title')}
              </span>
            </h3>
            <h2 className={CN.title}>
              {t('composite.slickSlider.slide3.description.part1')}
              {S.space}
              <span className={CN.textWave}>{t('composite.slickSlider.slide3.description.part2')}</span>
            </h2>
          </div>
        </div>
      </div>
      {/* SLIDE tipping */}
      {USE_SLIDE && (
        <div data-bem="SlickSlider__tipping" className={cn(CN.slideImage, CN.imageTipping)}>
          <div className={CN.container}>
            <div className={CN.description}>
              <h3 className={CN.subTitle}>
                <span className={CN.text}>
                  {S.poundBanknote} {t('composite.slickSlider.slide4.title')}
                </span>
              </h3>
              <h2 className={CN.title}>
                {t('composite.slickSlider.slide4.description.part1')}
                {S.space}
                <span className={CN.textWave}>{t('composite.slickSlider.slide4.description.part2')}</span>
              </h2>
              <div className={CN.linkContainer}>
                <ExternalLink variant="tertiaryLight" link={LINK_TIPPING} onClick={() => trackEvent('login_education')}>
                  <span className={CN.link}>{t('composite.slickSlider.slide4.learnMoreButton')}</span>
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      )}
    </Slider>
  );
};

export default SlickSlider;
